import { Injectable, isDevMode } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

let OAM_REMOTE_VALUE = '';

@Injectable()
export class OamRemoteUserInterceptor implements HttpInterceptor {
  constructor() {}

  protected addOamRemoteUserHeader(req: HttpRequest<unknown>): HttpRequest<unknown> {
    if (OAM_REMOTE_VALUE) {
      req = req.clone({ setHeaders: { OAM_REMOTE_USER: OAM_REMOTE_VALUE } });
    } else {
      const queryParams = new URLSearchParams(window.location.href.split('?')[1]);
      if (req.url.startsWith(environment.api.root) && queryParams.has('user')) {
        // use login from queryParamMap for development
        OAM_REMOTE_VALUE = queryParams.get('user');
        req = req.clone({ setHeaders: { OAM_REMOTE_USER: OAM_REMOTE_VALUE } });
      }
    }
    return req;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isDevMode()) {
      req = this.addOamRemoteUserHeader(req);
    }
    return next.handle(req);
  }
}
